import { render, staticRenderFns } from "./meetLodgingItem.vue?vue&type=template&id=035ba6d4"
import script from "./meetLodgingItem.vue?vue&type=script&lang=js"
export * from "./meetLodgingItem.vue?vue&type=script&lang=js"
import style0 from "./meetLodgingItem.vue?vue&type=style&index=0&id=035ba6d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports